import { useCartActions } from 'lib/cartState/actions';
import { usewpdataSelectors } from 'lib/wpdataState/selectors';
import { useCartSelectors } from 'lib/cartState/selectors';
import s from './Button.module.scss';
import { CSSProperties, useState } from 'react';
import axios from 'axios';
import { useproductsdataSelectors } from 'lib/productsState/selectors';

type CTAProps = {
  text: string;
  className: string;
  attribute?: string;
  style?: CSSProperties;
  handleClick?: () => void;
};

const Button = ({ text, className, attribute, style, handleClick }: CTAProps) => {
  const { Theme, Settings, Layout } = usewpdataSelectors();
  const [isLoading, setIsLoading] = useState(false);
  const { cartProducts, warrantyProduct, CartData } = useCartSelectors();
  const { Warranty, CampaignData } = useproductsdataSelectors();

  const isLink = Layout.hero.layout === 'lander';
  const cartDisabled = Settings.disableCart;
  const { toggleLoaderAction } = useCartActions();

  const handleSubmit = async () => {
    const requestData = {
      cartProducts: cartProducts,
      country: CartData.country,
      warrantyData: {
        ...Warranty,
        warrantyState: warrantyProduct.warrantyState,
        price: warrantyProduct.price,
      },
      formattedString: window.formattedString,
      campaignData: CampaignData,
    };

    try {
      setIsLoading(true);
      toggleLoaderAction();
      const url = '/wp-json/brands/cart/v1/session';
      const response = await axios.post(
        url,
        { payload: requestData },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      if (response.status === 200) {
        const urlSymbol = Settings.link.includes('?') ? '&' : '?';
        const urlParams = new URLSearchParams(window.location.search);
        const orderHash = urlParams.get('order') || '';
        const emailTemplate = urlParams.get('email_template') || '';
        window.location.href = `${Settings.link}/${urlSymbol}cart=${response.data.session_hash}&aff=${window.btoa(
          window.affiliate
        )}&entryUrl=${window.btoa(window.entry_url)}&postId=remote${orderHash ? `&order=${orderHash}` : ''}${
          emailTemplate ? `&email_template=${emailTemplate}` : ''
        }`;
      } else {
        toggleLoaderAction();
      }
    } catch (err) {
      toggleLoaderAction();
    } finally {
      toggleLoaderAction();
    }
  };

  if (isLink) {
    return (
      <a
        data-cy={attribute}
        style={style}
        href={Settings.link}
        data-theme={Theme?.button}
        className={`${className} cta ${s.cta}`}
      >
        {text}
      </a>
    );
  }

  return cartDisabled ? (
    <button
      style={style}
      data-cy={attribute}
      data-loading={isLoading}
      onClick={() => {
        handleSubmit();
      }}
      data-theme={Theme?.button}
      className={`${className} cta ${s.cta}`}
    >
      {text}
    </button>
  ) : (
    <button
      style={style}
      data-cy={attribute}
      onClick={handleClick}
      data-theme={Theme?.button}
      className={`${className} cta ${s.cta}`}
    >
      {text}
    </button>
  );
};

export default Button;
